export default __webpack_public_path__ + "static/media/FotoDouglas.bbe2b75f.jfif";